// Como o cliente leva o pedido. Restaurante (e todo Totem): Comer no Local ×
// Para Viagem. Mercearia/açougue no BALCÃO (pedido do dono, 29/09/2026):
// Levar agora × Entrega — Entrega passa o carrinho para o Novo Pedido do
// Delivery (ctx.passarParaEntrega). O modo vem de hooks/useModoConsumo.
// Teclado no Balcão: F3/F4 escolhem direto, Tab alterna o cartão aceso, Enter
// confirma e Esc volta ao cardápio. O cartão aceso começa na última escolha
// deste computador — menos "Entrega" (30/09/2026): depois de uma entrega o
// aceso volta a ser o de levar agora. Desde 29/09 o Balcão chega aqui direto
// do Finalizar, então o nome do cliente (opcional) fica no alto e no centro
// desta tela (NomeCliente).
import { ArrowLeft, Bike, ShoppingBag, UtensilsCrossed } from "lucide-react";
import { useState } from "react";

import { ID_BUSCA_CLIENTE } from "../components/BuscaClienteBalcao";
import NomeCliente from "../components/NomeCliente";
import TeclaAtalho from "../components/TeclaAtalho";
import { useAtalhosBalcao } from "../hooks/useAtalhosBalcao";

const CHAVE_ULTIMA = "balcao_tipo_consumo";
const OPCOES = {
  restaurante: [
    { tipo: "local", titulo: "Comer no Local", sub: "Consumir aqui", Icone: UtensilsCrossed, tecla: "F3" },
    { tipo: "viagem", titulo: "Para Viagem", sub: "Leve seu pedido com você", Icone: ShoppingBag, tecla: "F4" },
  ],
  mercearia: [
    { tipo: "levar_agora", titulo: "Levar agora", sub: "O cliente sai com a compra", Icone: ShoppingBag, tecla: "F3" },
    { tipo: "entrega", titulo: "Entrega", sub: "A loja entrega · abre o Delivery", Icone: Bike, tecla: "F4" },
  ],
};

// "entrega" nunca é lembrada (nem a gravada antes de 30/09/2026): o Enter
// sem olhar levaria a próxima venda para o Delivery.
function ultimaEscolha() {
  try { const v = localStorage.getItem(CHAVE_ULTIMA); return v === "entrega" ? null : v; } catch { return null; }
}

function CartaoConsumo({ opcao, aceso, teclado, onEscolher }) {
  const { tipo, titulo, sub, Icone, tecla } = opcao;
  return (
    <button onClick={() => onEscolher(tipo)} data-e2e={`consumo-${tipo}`} data-aceso={aceso ? "1" : "0"}
      className={`group flex-1 relative bg-gradient-to-br from-zinc-800/80 to-zinc-900/80 backdrop-blur-sm hover:from-zinc-700/90 hover:to-zinc-800/90 border-2 ${aceso ? "border-orange-500 ring-4 ring-orange-500/30" : "border-zinc-700/50"} hover:border-orange-500 rounded-3xl p-10 md:p-14 flex flex-col items-center gap-6 transition-all duration-300 active:scale-95 overflow-hidden shadow-2xl shadow-black/30`}>
      {teclado && <TeclaAtalho className="absolute top-4 right-4 text-sm text-zinc-200">{tecla}</TeclaAtalho>}
      <div className="absolute inset-0 bg-gradient-to-t from-orange-500/0 group-hover:from-orange-500/10 transition-all duration-500" />
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'radial-gradient(circle at center, rgba(249,115,22,0.08) 0%, transparent 70%)' }} />
      <div className="w-28 h-28 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-orange-500/15 to-orange-600/5 group-hover:from-orange-500/25 group-hover:to-orange-600/15 flex items-center justify-center transition-all duration-300 group-hover:scale-110 ring-2 ring-orange-500/10 group-hover:ring-orange-500/30">
        <Icone className="w-14 h-14 md:w-16 md:h-16 text-orange-500 transition-transform duration-300 group-hover:scale-110" />
      </div>
      <div className="text-center relative z-10">
        <span className="text-2xl md:text-3xl lg:text-4xl font-black text-zinc-100 block">{titulo}</span>
        <span className="text-base md:text-lg text-zinc-400 mt-2 block font-medium">{sub}</span>
      </div>
    </button>
  );
}

export default function TelaTipoConsumo({ ctx }) {
  const { setScreen, telaCls, setDeliveryType, companyLogo, chipCliente, autoAtendimento, modoConsumo, entregaDisponivel, passarParaEntrega } = ctx;
  const teclado = !autoAtendimento;
  // Delivery desligado em Preferências: a mercearia fica só com "Levar agora".
  const opcoes = OPCOES[teclado && modoConsumo === "mercearia" ? "mercearia" : "restaurante"]
    .filter((o) => o.tipo !== "entrega" || entregaDisponivel !== false);
  const [escolhaAcesa, setAceso] = useState(() => (teclado ? ultimaEscolha() : null));
  // A última escolha pode ser do outro modo (a loja trocou a preferência): aí acende a 1ª.
  const aceso = teclado ? (opcoes.some((o) => o.tipo === escolhaAcesa) ? escolhaAcesa : opcoes[0].tipo) : null;
  const voltar = () => setScreen(autoAtendimento ? "cart_review" : "menu");
  const escolher = (tipo) => {
    if (teclado && tipo !== "entrega") { try { localStorage.setItem(CHAVE_ULTIMA, tipo); } catch { /* sem memória: acende a 1ª */ } }
    if (tipo === "entrega") { passarParaEntrega(); return; }
    setDeliveryType(tipo);
    setScreen("payment");
  };
  useAtalhosBalcao({
    F3: () => escolher(opcoes[0].tipo),
    F4: () => (opcoes[1] ? escolher(opcoes[1].tipo) : false),
    Tab: () => setAceso(opcoes[1] && aceso === opcoes[0].tipo ? opcoes[1].tipo : opcoes[0].tipo),
    // Setas = Tab (pedido do dono): ← acende a da esquerda, → a da direita, ↑↓ alternam.
    ArrowLeft: () => setAceso(opcoes[0].tipo),
    ArrowRight: () => setAceso((opcoes[1] || opcoes[0]).tipo),
    ArrowUp: () => setAceso(opcoes[1] && aceso === opcoes[0].tipo ? opcoes[1].tipo : opcoes[0].tipo),
    ArrowDown: () => setAceso(opcoes[1] && aceso === opcoes[0].tipo ? opcoes[1].tipo : opcoes[0].tipo),
    Enter: () => escolher(aceso),
    Escape: () => voltar(),
    // F2 = busca de cliente (pedido do dono, 29/09/2026).
    F2: () => { const campo = document.getElementById(ID_BUSCA_CLIENTE); if (!campo) return false; campo.focus(); return true; },
  }, teclado);
  return (
    <div className={`${telaCls} bg-zinc-950 flex flex-col select-none overflow-hidden`}>
      {/* Animated background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-15%] left-[20%] w-[50vw] h-[50vw] rounded-full bg-orange-500/5 blur-3xl animate-pulse" style={{ animationDuration: '5s' }} />
        <div className="absolute bottom-[-10%] right-[10%] w-[40vw] h-[40vw] rounded-full bg-amber-500/5 blur-3xl animate-pulse" style={{ animationDuration: '7s', animationDelay: '2s' }} />
      </div>

      <div className="absolute top-6 left-6 right-6 z-20 flex items-center justify-between">
        <button onClick={voltar} className="flex items-center gap-2 text-zinc-500 hover:text-zinc-200 transition-colors">
          <ArrowLeft className="w-5 h-5" /><span className="text-sm">Voltar</span>{teclado && <TeclaAtalho>Esc</TeclaAtalho>}
        </button>
        {teclado ? <NomeCliente ctx={ctx} /> : chipCliente("ml-auto")}
      </div>
      <div className={`flex-1 flex flex-col items-center justify-center px-8 relative z-10 ${teclado ? "pt-16" : ""}`}>
        {/* Logo small */}
        {companyLogo && (
          <div className="mb-4">
            <img src={companyLogo} alt="Logo" className="w-16 h-16 md:w-20 md:h-20 object-contain opacity-80" onError={(e) => { e.target.style.display = 'none'; }} />
          </div>
        )}
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-zinc-100 to-zinc-300 mb-3">Como deseja consumir?</h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full mx-auto" />
        </div>
        <div className="flex gap-8 md:gap-12 w-full max-w-4xl">
          {opcoes.map((o) => <CartaoConsumo key={o.tipo} opcao={o} aceso={aceso === o.tipo} teclado={teclado} onEscolher={escolher} />)}
        </div>
        {teclado && (
          <p className="mt-8 text-sm text-zinc-500 flex items-center gap-2" data-e2e="consumo-dica">
            <TeclaAtalho>Tab</TeclaAtalho> ou <TeclaAtalho>← →</TeclaAtalho> alterna · <TeclaAtalho>Enter</TeclaAtalho> confirma
          </p>
        )}
      </div>
    </div>
  );
}
